import CSlider from "@/components/main/CSlider";
import { Container, Skeleton } from "@mantine/core";
import React from "react";
import SingleCardExpertTestimonialSkeleton from "../expert testimonials/SingleCardExpertTestimonialSkeleton";

export default function OrganizationTestimonialsSkeleton() {
  let carousalItems = Array.from(Array(8)).map((item, index) => {
    return {
      id: index,
      component: <SingleCardExpertTestimonialSkeleton key={index} />,
    };
  });

  return (
    <div className="py-[76px] pb-[100px] my-[57px]">
      <Container className="mb-4">
        <Skeleton height={30} width={107} />
        <Skeleton height={70} className="max-w-[300px]" my={4} />
        <Skeleton height={20} width={250} />
      </Container>
      <Container>
        <div className="lg:w-screen w-full">
          <CSlider items={carousalItems} />
        </div>
      </Container>
    </div>
  );
}
